import styled from 'styled-components';
import { Cloud, Database, Server, Lightbulb, Users, Diamond } from 'lucide-react';
import dataEngineeringImage from '../images/dataEngineer.png';
import bg12 from '../images/bg12.png';
import bg13 from '../images/bg13.png';
import bg14 from '../images/bg14.png';
import { useNavigate } from 'react-router-dom';

const AboutUs = () => {
    const navigate = useNavigate();

    return (
      <AboutContainer>
     <Hero>
  <h1>Qui sommes-nous?</h1>
  <p>Créée en 2023, DataVision Solutions est votre partenaire expert en transformation digitale et solutions cloud innovantes.</p>
  <HeroImage>
    <img src={bg12} alt="Technologies illustration" />
  </HeroImage>
  <p>Notre expertise vous accompagne dans la modernisation de vos infrastructures technologiques, l'optimisation de vos données et la transformation de vos processus métiers.</p>
  <Button>En Savoir Plus</Button>
</Hero>
  
    {/* NOTRE EXPERTISE */}
        <Section>
        <SectionTitle>NOTRE EXPERTISE</SectionTitle>
        <h2>Une équipe d'innovateurs<br />technologiques</h2>
        <p>Notre équipe réunit des talents passionnés qui conçoivent des solutions digitales personnalisées pour répondre à vos enjeux spécifiques.</p>
          <ExpertiseGrid>
            <ExpertiseCard>
              <Database className="icon" size={32} />
              <h3>Big Data</h3>
              <p>Expertise en traitement des données massives</p>
            </ExpertiseCard>
            <ExpertiseCard>
              <Cloud className="icon" size={32} />
              <h3>Cloud</h3>
              <p>Solutions cloud innovantes et évolutives</p>
            </ExpertiseCard>
            <ExpertiseCard>
              <Server className="icon" size={32} />
              <h3>Intégration Continue</h3>
              <p>Automatisation et déploiement continu</p>
            </ExpertiseCard>
          </ExpertiseGrid>
        </Section>
  
    {/* NOTRE MISSION */}
        <Section>
        <SectionTitle>NOTRE MISSION</SectionTitle>
        <h2>Valoriser le potentiel<br />de vos données</h2>
          <img src={bg13} alt="Graph" style={{ maxWidth: '800px', width: '100%', marginBottom: '2rem' }} />
          <p>De l'analyse prédictive à l'intelligence opérationnelle, nous développons des stratégies data-driven qui créent de la valeur mesurable pour votre entreprise.</p>
          <Button onClick={() => navigate('/services')}>Nos Services</Button>
        </Section>
  
      {/* NOS VALEURS */}
        <Section>
        <SectionTitle>NOS VALEURS</SectionTitle>
        <h2>Les piliers de notre<br />réussite collective</h2>
          <ValuesGrid>
            <ValueCard>
              <Lightbulb className="icon" size={32} />
              <h3>Innovation</h3>
              <p>L'innovation guide chacune de nos actions pour créer des solutions d'avenir.</p>
            </ValueCard>
            <ValueCard>
              <Users className="icon" size={32} />
              <h3>Collaboration</h3>
              <p>Le succès naît du partage des idées et de la synergie des compétences.</p>
            </ValueCard>
            <ValueCard>
              <Diamond className="icon" size={32} />
              <h3>Excellence</h3>
              <p>La qualité et la performance sont au cœur de nos engagements.</p>
            </ValueCard>
          </ValuesGrid>
        </Section>
  
    
      {/* POURQUOI NOUS CHOISIR? */}
        <Section>
        <SectionTitle>POURQUOI NOUS CHOISIR?</SectionTitle>
        <h2>Une expertise polyvalente,<br />des solutions sur mesure</h2>
        <p>Notre savoir-faire s'étend à de multiples secteurs d'activité, de la santé à l'industrie, en passant par les services financiers.</p>
          <img src={bg14} alt="Expertise illustration" style={{ maxWidth: '600px', width: '100%', marginBottom: '2rem' }} />
          <p>Chaque projet bénéficie de notre approche innovante et de notre maîtrise des technologies émergentes pour créer un impact durable.</p>
        </Section>
  

      </AboutContainer>
    );
  };
  
  export default AboutUs;

  const AboutContainer = styled.div`
  min-height: 100vh;
  padding: 4rem 2rem;
`;

const Hero = styled.section`
  text-align: center;
  max-width: 1000px;
  margin: 0 auto 6rem;

  h1 {
    font-size: 3.5rem;
    margin-bottom: 2rem;
  }

  p {
   font-size: 1.2rem;
    color: #94a3b8;
    margin-bottom: 3rem;
  }
`;

const HeroImage = styled.div`
  position: relative;
  max-width: 700px;
  margin: 4rem auto;
  
  img {
    width: 100%;
    height: auto;
  }
`;

const Button = styled.button`
  background: #2563eb;
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 0.5rem;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s;

  &:hover {
    background: #1d4ed8;
  }
`;

const SectionTitle = styled.div`
 color: #60a5fa;
 font-weight: 600;
 margin-bottom: 2rem;
 text-transform: uppercase;
 letter-spacing: 1px;
`;

const Section = styled.section`
  margin-bottom: 6rem;
  text-align: center;

  h2 {
    font-size: 2.5rem;
    margin-bottom: 2rem;
    
    span {
      color: #94a3b8;
    }
  }

  p {
    color: #94a3b8;
    max-width: 700px;
    margin: 0 auto 3rem;
    line-height: 1.6;
     font-size: 1.2rem;
  }
`;

const ExpertiseGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const ExpertiseCard = styled.div`
  background: rgba(0, 0, 0, 0.3);
  border-radius: 1rem;
  padding: 2rem;
  text-align: left;

  h3 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }

  p {
    color: #94a3b8;
    font-size: 0.9rem;
  }

  .icon {
    color: #2563eb;
    margin-bottom: 1rem;
  }
`;

const ValuesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  margin-top: 5rem;
`;

const ValueCard = styled.div`
  background: rgba(0, 0, 0, 0.3);
  border-radius: 1rem;
  padding: 2rem;
  
  .icon {
    color: #2563eb;
    margin-bottom: 1rem;
  }

  h3 {
    margin-bottom: 1rem;
  }

  p {
    color: #94a3b8;
    font-size: 0.9rem;
    margin: 0;
  }
`;